<template>
  <div :class="{'has-logo':showLogo}">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item v-for="route in routes" :key="route.path" :item="route" :base-path="route.path" />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Logo from './Logo'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'

export default {
  components: { SidebarItem, Logo },
  computed: {
    ...mapGetters([
      'sidebar'
    ]),
    routes() {
      const routes = this.$router.options.routes
      // 非推广合伙人时隐藏合伙人菜单（顶层或子路由带 meta.agent 均隐藏）
      if (this.$store.getters.isAgent) {
        return routes
      }
      const isAgentRoute = r => !!(r.meta && r.meta.agent)
      return routes
        .filter(r => {
          if (isAgentRoute(r)) return false
          // 子路由全部是合伙人页面时，父级菜单也一并隐藏
          if (r.children && r.children.length && r.children.every(isAgentRoute)) {
            return false
          }
          return true
        })
        .map(r => {
          if (!r.children || !r.children.length) return r
          const children = r.children.filter(c => !isAgentRoute(c))
          return Object.assign({}, r, { children })
        })
    },
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  }
}
</script>
